// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"176":"projects","242":"project"}[chunkId] + "." + {"176":"053d6120","242":"b308d1d0"}[chunkId] + ".css";
};